export default __webpack_public_path__ + "static/flag-zambia-a782efeffca8ed41345da46219806d01.svg";